export default __webpack_public_path__ + "static/media/btnSuccess.bba6b875.webp";